import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchJobs, searched, sorted } from '../features/jobs/jobSlice';
import handleInput from '../utils/handleInput';
import Job from './Job';

const JobList = () => {
  const { jobs, isLoading, isError, error, filter, search, sort } = useSelector(
    (state) => state.jobs
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchJobs());
  }, [dispatch]);

  const handleChange = (e) => {
    const inputValue = handleInput(e);

    if (e.target.name === 'search') {
      dispatch(searched(inputValue));
    }

    if (e.target.name === 'sort') {
      dispatch(sorted(inputValue));
    }
  };

  // decide what to render
  let content = null;

  if (isLoading) {
    content = <p>Loading...</p>;
  }
  if (!isLoading && isError) {
    content = <p>{error}</p>;
  }
  if (!isLoading && !isError && jobs?.length === 0) {
    content = <p>No jobs found!</p>;
  }
  if (!isLoading && !isError && jobs?.length > 0) {
    content = jobs
      .filter((job) => {
        if (filter === '') {
          return true;
        } else {
          return job.type === filter;
        }
      })
      .filter((job) => job.title.toLowerCase().includes(search.toLowerCase()))
      .sort((a, b) => {
        if (sort === 'Salary (High to Low)') {
          return Number(b.salary) - Number(a.salary);
        }
        if (sort === 'Salary (Low to High)') {
          return Number(a.salary) - Number(b.salary);
        }
        return true;
      })
      .map((job) => <Job key={job.id} job={job} />);
  }

  return (
    <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
      <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
        <h1 className="lws-section-title">All Available Jobs</h1>
        <div className="flex gap-4">
          <div className="search-field group flex-1">
            <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
            <input
              type="text"
              placeholder="Search Job"
              className="search-input"
              id="lws-searchJob"
              name="search"
              value={search}
              onChange={handleChange}
            />
          </div>
          <select
            id="lws-sort"
            name="sort"
            autoComplete="sort"
            className="flex-1"
            value={sort}
            onChange={handleChange}
          >
            <option>Default</option>
            <option>Salary (Low to High)</option>
            <option>Salary (High to Low)</option>
          </select>
        </div>
      </div>

      <div className="jobs-list">{content}</div>
    </main>
  );
};

export default JobList;
